<template>
  <div
    v-if="loading || error"
    class="clipr-page-load-overlay"
    :class="{
      'clipr-page-load-overlay--error': !!error,
      'clipr-page-load-overlay--fixed': fixed,
    }"
    aria-live="polite"
  >
    <clipr-loader
      v-if="loading"
      :title="title"
      :subtitle="subtitle"
    />
    <clipr-loader
      v-else
      error
      role="alert"
      :title="errorMessage"
    >
      <button
        v-if="showRefresh"
        type="button"
        class="btn btn-outline-primary btn-sm clipr-page-load-refresh-btn"
        @click="$emit('refresh')"
      >
        <i class="ti-reload mr-1"></i>
        {{ refreshLabel }}
      </button>
    </clipr-loader>
  </div>
</template>

<script>
import CliprLoader from "@/components/clipr/CliprLoader.vue";

export default {
  name: "CliprPageLoadOverlay",
  components: {
    CliprLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    refreshLabel: {
      type: String,
      default: "Recargar",
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.clipr-page-load-overlay {
  position: absolute;
  inset:
    calc(-1 * var(--page-overlay-offset-y, 50px))
    calc(-1 * var(--page-overlay-offset-x, 45px))
    calc(-1 * var(--page-overlay-offset-y, 50px))
    calc(-1 * var(--page-overlay-offset-x, 45px));
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top, rgba(168, 85, 247, 0.16) 0%, transparent 42%),
    radial-gradient(circle at bottom, rgba(59, 130, 246, 0.12) 0%, transparent 48%),
    rgba(7, 9, 18, 0.93);
  backdrop-filter: blur(6px);
}

.clipr-page-load-overlay--fixed {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.clipr-page-load-overlay--error {
  background:
    radial-gradient(circle at top, rgba(239, 68, 68, 0.16) 0%, transparent 44%),
    rgba(10, 8, 14, 0.95);
}

.clipr-page-load-refresh-btn {
  min-width: 136px;
}
</style>
